<section class="content">
    <div class="row">
        <div class="box  box-primary" style="border: 1px solid #d2d6de !important;">
                <div class="row">
                    
                    <div class="col-sm-10 col-sm-offset-1">
                      <section class="content-header">
                        <button pButton type="button" icon="pi pi-chevron-left"
          class="p-button-text" (click)="prevMonth()"></button>
                        <!-- <h1 class="text-center">
                            {{current_date | date:'MMMM yyyy'}}
                        </h1> -->
                         <div class="fc-center" style="display: flex;">
                                            
                                                <select class="form-control noBorderSearch" [(ngModel)]="currentMonth" name="currentMonth" (change)="onMonthYearChange()" style="	width: auto;
                                                                font-size: 15px;
                                                                text-align-last: center;
                                                                padding-right: 0px;">
                                                    <option value="{{item.value}}" *ngFor="let item of MonthList" style="direction: rtl; ">
                                                         {{item.text}}
                                                    </option>
                                                </select>

                                                <select class="form-control  noBorderSearch" [(ngModel)]="currentYear" name="currentYear" (change)="onMonthYearChange()" style="	width: auto;
                                                                font-size: 15px;
                                                                text-align-last: center;
                                                                padding: 6px 5px;">
                                                    <option value="{{item.value}}" *ngFor="let item of YearList" style="direction: rtl; ">
                                                        {{item.text}}
                                                    </option>
                                                </select>

                                        </div>
                        <button pButton type="button" icon="pi pi-chevron-right"
          class="p-button-text" (click)="nextMonth()"
          *ngIf="!isNextDisabled()"></button>
                       </section>
                       <section class="content mt-4">
                            <div class="row">
                                <div class="col-lg-6 col-md-6 mb-3">
                                    <div class="box ibox box-info ">
                                        <div class="box-header with-border text-center">
                                            <h4 class="box-title"><strong>Home Program Interactions</strong></h4>
                                        </div>
                                        <div class="box-body p-3">
                                            <div >
                                                <p-chart type="bar" [data]="bardata" [options]="baroptions"
                                            ></p-chart>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-6 col-md-6 mb-3">
                                    <div class="box ibox box-info">
                                        <div class="box-header with-border text-center">
                                            <h4 class="box-title"><strong>Monthly Tasks</strong></h4>
                                        </div>
                                        <div class="box-body p-3">
                                            <div>
                                                <p-chart type="bar" [data]="monthlyTaskData" [options]="monthlyTaskOptions"
                                                ></p-chart>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-6 col-md-6 mb-3">
                                    <div class="box ibox box-info">
                                        <div class="box-header with-border text-center">
                                            <h4 class="box-title"><strong>Monthly Repairs</strong></h4>
                                        </div>
                                        <div class="box-body p-3">
                                            <div>
                                                <p-chart type="bar" [data]="basicData" [options]="basicOptions"></p-chart>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-6 col-md-6 mb-3">
                                    <div class="box ibox box-info ">
                                        <div class="box-header with-border text-center">
                                            <h4 class="box-title"><strong>Monthly Parts Cost</strong></h4>
                                        </div>
                                        <div class="box-body p-3">
                                            <div>
                                                <p-chart type="bar" [data]="monthlyRepairCostData" [options]="monthlyRepairCostOptions"
                                                ></p-chart>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
        </div>
    </div>
</section>
